import React from 'react';

export default {
  strong: (chunks) => <strong>{chunks}</strong>,
  b: (chunks) => <b>{chunks}</b>,
  p: (chunks) => <p>{chunks}</p>,
  i: (chunks) => <i>{chunks}</i>,
  em: (chunks) => <em>{chunks}</em>,
  br: <br />,
  nbsp: <>&nbsp;</>,
};
